import { ArticleCardTimed } from '@/app_components/ArticleSections/ArticleCards/ArticleCardTimed';
import { StrikethroughHeading } from '@/app_components/ArticleSections/Heading';
import type { ArticlePreview } from '@/app_lib/types/ArticlePreview';
import { ContentPlacement } from '@/app_lib/types/analytics';
import type { EventData } from '@/app_lib/types/Gtm';
import { cn } from '@/app_lib/utils/utils';

interface ArticleSectionRelatedProps {
  articles: ArticlePreview[];
  className?: string;
  heading: string;
  priority?: boolean;
  trackingData?: EventData;
}

const defaultTrackingData: EventData = {
  // biome-ignore lint/style/useNamingConvention: gtm data
  contentPlacementCD: 'latest - bottom',
  eventAction: 'latest module click',
  eventCategory: 'navigation',
};

export const ArticleSectionRelated = ({
  articles,
  className,
  heading,
  priority,
  trackingData = defaultTrackingData,
}: ArticleSectionRelatedProps) => {
  const recirculationArray = articles.map((article) => article.title);

  return (
    <div
      className={cn('flex flex-col layout-gap-md w-full', className)}
      data-cy={ContentPlacement.ArticleTitle}
      data-recirculation-array={recirculationArray}
      data-recirculation-name={heading}
    >
      <StrikethroughHeading id='latest-popular-module'>{heading}</StrikethroughHeading>
      <div
        className='flex flex-col gap-xl md:layout-grid-gap md:grid md:grid-cols-3 latest-popular-content'
        data-cy={ContentPlacement.PostList}
      >
        {articles.map((article, index) => (
          <div key={article.url}>
            <ArticleCardTimed
              article={article}
              index={index + 1}
              priority={priority}
              trackingData={trackingData}
            />
          </div>
        ))}
      </div>
    </div>
  );
};
